module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAOElEQVQokWN88fr9fwYiAROxCkcVU6SYBZnTNXk5hoKy3EjsJiNLYONjOAOmAF0hCDCOpo3BpxgA0KsPnYNGk2QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzttb1-1.png
// module id = 423
// module chunks = 0